<template>
  <b-form-input
    v-model="local_value"
    :autofocus="autofocus"
    :disabled="disabled"
    :form="form"
    :id="id"
    :name="name"
    :placeholder="placeholder"
    :required="required"
    :size="size"
    :state="state"
    maxlength="18"
    @blur="blur"
    @focus="focus"
    @keypress="keypress"
  />
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: 0,
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md",
    },
    allow_cpf: {
      type: Boolean,
      default: false,
    },
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({}),
  computed: {
    local_value: {
      set(value) {
        value = value.toString().replace(/[^\d]/g, "");
        this.$emit("input", value);
      },
      get() {
        let value = this.value.toString();
        let $1, $2, $3, $4, $5;
        let response = "";

        if (this.allow_cpf && value.length <= 11) {
          $1 = value.slice(0, 3);
          $2 = value.slice(3, 6);
          $3 = value.slice(6, 9);
          $4 = value.slice(9, 11);

          response = $1;
          $2 ? (response += "." + $2) : "";
          $3 ? (response += "." + $3) : "";
          $4 ? (response += "-" + $4) : "";
        } else {
          $1 = value.slice(0, 2);
          $2 = value.slice(2, 5);
          $3 = value.slice(5, 8);
          $4 = value.slice(8, 12);
          $5 = value.slice(12, 14);

          response = $1;
          $2 ? (response += "." + $2) : "";
          $3 ? (response += "." + $3) : "";
          $4 ? (response += "/" + $4) : "";
          $5 ? (response += "-" + $5) : "";
        }

        return response;
      },
    },
  },
  methods: {
    clearValue() {
      this.local_value = null;
    },
    blur() {
      this.$emit("blur");
    },
    focus() {
      this.$emit("focus");
    },
    keypress(evt) {
      let keyCode = evt.keyCode ? evt.keyCode : evt.which;
      if (keyCode < 48 || keyCode > 57) {
        evt.preventDefault();
      }
    },
  },
  watch: {},
  async created() {},
};
</script>
